module.exports = __webpack_public_path__ + "static/media/go4rent.71312809.png";